export default "__VITE_ASSET__D7m4NdCg__"